export const creditLimitIncreasePreferenceOptions = [
    { value: 'Automatic', label: 'Automatic' },
    { value: 'LetUsKnow', label: 'Let Us Know' },
    { value: 'NoIncreases', label: 'No Increases' }
  ];
  